import React, { useState } from 'react';
import { Card, Tab, Tabs } from 'react-bootstrap';
import AbaGuias from './AbaGuias';
import AbaListagem from './AbaListagem';
import { CFG } from './constants';

export default function RelatoriosFaturamento() {
  const [tabKey, setTabKey] = useState('guias');

  return (
    <Card style={{ marginTop: 10 }}>
      <Card.Header className="text-center font-weight-bold">
        Relatórios de Faturamento
      </Card.Header>
      <Card.Body>
        <Tabs
          id="tabs-relatorios-faturamento"
          activeKey={tabKey}
          onSelect={k => setTabKey(k)}
          className="mb-3"
        >
          <Tab eventKey="guias" title="Guias e Convênios">
            <AbaGuias ativo={tabKey === 'guias'} />
          </Tab>
          <Tab eventKey="internados" title="Internados">
            <AbaListagem
              ativo={tabKey === 'internados'}
              tituloPdf="Listagem de Internados"
              convenios={CFG.internados.convenios}
              procedimentos={CFG.internados.procedimentos}
            />
          </Tab>
          <Tab eventKey="ambulatorio" title="Ambulatório">
            <AbaListagem
              ativo={tabKey === 'ambulatorio'}
              tituloPdf="Listagem de Ambulatório"
              convenios={CFG.ambulatorio.convenios}
              procedimentos={CFG.ambulatorio.procedimentos}
            />
          </Tab>
          <Tab eventKey="mac" title="MAC">
            <AbaListagem
              ativo={tabKey === 'mac'}
              tituloPdf="Listagem MAC"
              convenios={CFG.mac.convenios}
              procedimentos={CFG.mac.procedimentos}
            />
          </Tab>
          <Tab eventKey="cross" title="CROSS">
            <AbaListagem
              ativo={tabKey === 'cross'}
              tituloPdf="Listagem CROSS"
              convenios={CFG.cross.convenios}
              procedimentos={CFG.cross.procedimentos}
            />
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
}
